      // fix judgeme carousel all reviews link
      (function () {
        function fixReviewLinks() {
          document.querySelectorAll('a[href*="pages/reviews"]').forEach(a => {
            if (a.getAttribute('href') !== '/pages/reviews') {
              a.setAttribute('href', '/pages/reviews');
            }
          });
        }

        fixReviewLinks();

        new MutationObserver(fixReviewLinks).observe(document.body, {
          childList: true,
          subtree: true
        });
      })();      


//   {% comment %} begin popupsmart fix {% endcomment %}
    // <!--
    //   Popupsmart mobile close-button fix — v2.

    //   Part A (unchanged from before): if a tap lands on Popupsmart's own close
    //   button but their handler doesn't actually close the widget, force it shut.

    //   Part B (new): the mobile screenshot shows the close icon isn't rendering at
    //   all on iOS — the button is there and tappable (that's why Part A already
    //   works) but visually invisible. Rather than guess at Popupsmart's icon/color
    //   CSS, this draws our own small always-visible close pill positioned over the
    //   popup card (the element with data-element="canvas", confirmed from your
    //   DevTools inspection) so visibility no longer depends on their rendering at
    //   all. It repositions on resize/orientation change and removes itself the
    //   moment the popup closes by any means (their button, ours, outside tap, etc).

    //   Scoped to viewport widths <= 768px only, since desktop already renders the
    //   real close button correctly and doesn't need a duplicate.

    // -->

    (function () {
      'use strict';

      var CONTAINER_PREFIX = 'popupsmart-container-';
      var CLOSE_BTN_SELECTOR = '[data-element="close-button"]';
      var CANVAS_SELECTOR = '[data-element="canvas"]';
      var GRACE_PERIOD_MS = 200;
      var MOBILE_MAX_WIDTH = 768;
      var FALLBACK_BTN_ID = 'pm-fallback-close';

      function isVisible(el) {
        if (!el) return false;
        var style = window.getComputedStyle(el);
        return style.display !== 'none' &&
              style.visibility !== 'hidden' &&
              el.offsetParent !== null;
      }

      function isMobile() {
        return window.innerWidth <= MOBILE_MAX_WIDTH;
      }

      function forceClose(container) {
        container.style.setProperty('display', 'none', 'important');
        document.documentElement.style.removeProperty('overflow');
        document.body.style.removeProperty('overflow');
        removeFallbackButton();
      }

      function findPopupsmartContainer(path) {
        for (var i = 0; i < path.length; i++) {
          var el = path[i];
          if (el && typeof el.id === 'string' && el.id.indexOf(CONTAINER_PREFIX) === 0) return el; 
        }
        return null;
      }

      // ---- Part A: force-close if their own button tap doesn't take ----

      function handlePossibleCloseTap(e) {
        var path = typeof e.composedPath === 'function' ? e.composedPath() : [e.target];
        var container = findPopupsmartContainer(path);
        if (!container) return;

        var hit = path[0];
        if (!(hit && hit.closest && hit.closest(CLOSE_BTN_SELECTOR))) return;

        setTimeout(function () {
          if (isVisible(container)) forceClose(container);
        }, GRACE_PERIOD_MS);
      }

      document.addEventListener('click', handlePossibleCloseTap, true);
      document.addEventListener('touchend', handlePossibleCloseTap, { capture: true, passive: true });

      // ---- Part B: draw our own guaranteed-visible close pill on mobile ----

      var fallbackBtn = null;
      var repositionHandlersBound = false;
      var watchedContainer = null;

      function removeFallbackButton() {
        if (fallbackBtn) {
          fallbackBtn.remove();
          fallbackBtn = null;
        }
        watchedContainer = null;
      }

      function positionFallbackButton() {
        if (!fallbackBtn || !watchedContainer) return;
        var canvas = watchedContainer.shadowRoot &&
                    watchedContainer.shadowRoot.querySelector(CANVAS_SELECTOR);
        var rect = (canvas || watchedContainer).getBoundingClientRect();
        // If the popup itself is gone/collapsed, clean up rather than pin to (0,0)
        if (rect.width === 0 && rect.height === 0) {
          removeFallbackButton();
          return;
        }
        fallbackBtn.style.top = (rect.top + 10) + 'px';
        fallbackBtn.style.left = (rect.right - 40) + 'px';
      }

      function ensureFallbackButton(container) {
        if (!isMobile()) return;
        if (fallbackBtn) return; // already showing for this popup

        watchedContainer = container;
        fallbackBtn = document.createElement('button');
        fallbackBtn.id = FALLBACK_BTN_ID;
        fallbackBtn.type = 'button';
        fallbackBtn.setAttribute('aria-label', 'Close popup');
        fallbackBtn.textContent = '\u00D7'; // ×
        Object.assign(fallbackBtn.style, {
          position: 'fixed',
          width: '30px',
          height: '30px',
          borderRadius: '50%',
          border: 'none',
          background: 'rgba(0,0,0,0.55)',
          color: '#fff',
          fontSize: '20px',
          lineHeight: '28px',
          textAlign: 'center',
          padding: '0',
          margin: '0',
          cursor: 'pointer',
          zIndex: 2147483647
        });
        fallbackBtn.addEventListener('click', function () {
          forceClose(container);
        });
        document.body.appendChild(fallbackBtn);
        positionFallbackButton();

        if (!repositionHandlersBound) {
          window.addEventListener('resize', positionFallbackButton);
          window.addEventListener('orientationchange', positionFallbackButton);
          repositionHandlersBound = true;
        }

        // Keep the pill glued to the card as Popupsmart's own layout settles
        // (content/images loading in can shift its height briefly).
        var settleTicks = 0;
        var settleInterval = setInterval(function () {
          positionFallbackButton();
          settleTicks++;
          if (settleTicks > 10 || !fallbackBtn) clearInterval(settleInterval);
        }, 200);

        // If the popup gets closed by some other means (outside tap, form
        // submit, etc.), stop showing our pill.
        var styleObserver = new MutationObserver(function () {
          if (!isVisible(container)) {
            removeFallbackButton();
            styleObserver.disconnect();
          }
        });
        styleObserver.observe(container, { attributes: true, attributeFilter: ['style'] });
      }

      function scanForPopupsmart() {
        if (!isMobile()) return;
        var containers = document.querySelectorAll('[id^="' + CONTAINER_PREFIX + '"]');
        containers.forEach(function (container) {
          if (isVisible(container)) ensureFallbackButton(container);
        });
      }

      scanForPopupsmart();
      var bodyObserver = new MutationObserver(scanForPopupsmart);
      bodyObserver.observe(document.body, { childList: true, subtree: true });
    })();

//    {% comment %} end popupsmart fix {% endcomment %}      

